module.exports = __webpack_public_path__ + "static/media/TheoWyesDavid_Logo_thick.d79ac106.png";